(() => {
  const ROOT_ID = 'll-quick-add';
  let lastFocus = null;
  let state = {
    product: null,
    variantId: null,
    purchase: 'onetime',
    planId: '',
    qty: 1,
  };

  const escapeHtml = (value) =>
    String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const cartAddUrl = () => {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}cart/add.js`;
  };

  const unpatchedFetch = (url, options) =>
    new Promise((resolve, reject) => {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('hidden', '');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
      let started = false;
      let settled = false;
      const finish = (cb, value) => {
        if (settled) return;
        settled = true;
        iframe.remove();
        cb(value);
      };
      const run = () => {
        if (started) return;
        started = true;
        const fetchFn = iframe.contentWindow && iframe.contentWindow.fetch;
        if (typeof fetchFn !== 'function') {
          finish(reject, new Error('Cart request failed'));
          return;
        }
        fetchFn
          .call(iframe.contentWindow, url, options)
          .then((res) =>
            res.text().then((text) => {
              finish(
                resolve,
                new Response(text, { status: res.status, statusText: res.statusText })
              );
            })
          )
          .catch((err) => finish(reject, err));
      };
      iframe.addEventListener('load', run, { once: true });
      document.documentElement.appendChild(iframe);
      try {
        if (iframe.contentDocument && iframe.contentDocument.readyState === 'complete') run();
      } catch (err) {
        /* ignore */
      }
    });

  const addToCart = (formData) => {
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    };
    const url = cartAddUrl();
    return unpatchedFetch(url, options).catch(() => fetch(url, options));
  };

  const cartUi = () => document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const isCartPage = () => Boolean(document.querySelector('main[data-template="cart"] cart-items'));

  const parseHTML = (html) => new DOMParser().parseFromString(html || '', 'text/html');

  const recsSectionEl = () =>
    document.getElementById('shopify-section-cart-recs') ||
    document.querySelector('[id^="shopify-section-"][id$="__cart-recs"]');

  const cartPageSectionIds = () => {
    const ids = [];
    const itemsId = document.getElementById('main-cart-items')?.dataset?.id;
    const footerId = document.getElementById('main-cart-footer')?.dataset?.id;
    ids.push(itemsId || 'cart-items');
    ids.push(footerId || 'cart-footer');
    ids.push('cart-icon-bubble');
    const recs = recsSectionEl();
    ids.push(recs?.id ? recs.id.replace(/^shopify-section-/, '') : 'cart-recs');
    return ids;
  };

  const sectionHTML = (sections, id) => {
    if (!sections || !id) return '';
    if (typeof sections[id] === 'string' && sections[id]) return sections[id];
    const match = Object.keys(sections).find(
      (key) =>
        (key === id || key.endsWith(`__${id}`) || key.endsWith(id)) &&
        typeof sections[key] === 'string' &&
        sections[key]
    );
    return match ? sections[match] : '';
  };

  const applyCartPageSections = (sections) => {
    if (!sections) return false;
    const itemsHTML = sectionHTML(sections, 'cart-items');
    const footerHTML = sectionHTML(sections, 'cart-footer');
    let updated = false;

    const itemsHost = document.querySelector('main[data-template="cart"] cart-items');
    if (itemsHost && itemsHTML) {
      const source = parseHTML(itemsHTML).querySelector('cart-items');
      if (source) {
        itemsHost.className = source.className;
        itemsHost.innerHTML = source.innerHTML;
        updated = true;
      }
    }

    const footer = document.getElementById('main-cart-footer');
    if (footer && footerHTML) {
      const source = parseHTML(footerHTML).getElementById('main-cart-footer');
      if (source) {
        footer.className = source.className;
        footer.innerHTML = source.innerHTML;
        updated = true;
      }
    }

    const icon = document.getElementById('cart-icon-bubble');
    const iconHTML = sectionHTML(sections, 'cart-icon-bubble');
    if (icon && iconHTML) {
      const doc = parseHTML(iconHTML);
      const source = doc.querySelector('.shopify-section') || doc.body;
      icon.innerHTML = source.innerHTML;
    }

    const recsWrap = recsSectionEl();
    const recsHTML = sectionHTML(sections, 'cart-recs');
    if (recsWrap && recsHTML) {
      const doc = parseHTML(recsHTML);
      const source = doc.getElementById(recsWrap.id) || doc.querySelector('.shopify-section, .ll-cart-recs');
      if (source) recsWrap.innerHTML = source.innerHTML;
    }

    return updated;
  };

  const refreshCartPage = async (addData) => {
    if (addData && addData.sections && applyCartPageSections(addData.sections)) {
      return addData;
    }
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    const url = `${cartUrl}?sections=${cartPageSectionIds().join(',')}`;
    const res = await unpatchedFetch(url).catch(() => fetch(url));
    const payload = await res.json();
    const sections = payload.sections || payload;
    applyCartPageSections(sections);
    return payload;
  };

  const root = () => {
    const el = document.getElementById(ROOT_ID);
    if (el && el.parentElement !== document.body) document.body.appendChild(el);
    return el;
  };
  const bodyEl = () => root() && root().querySelector('[data-ll-quick-body]');

  const currentVariant = () => {
    if (!state.product) return null;
    return state.product.variants.find((v) => String(v.id) === String(state.variantId)) || state.product.variants[0];
  };

  const variantHaystack = (variant) =>
    [variant && variant.label, ...((variant && variant.options) || [])].join(' ').toLowerCase();

  const findStarterVariant = (product, starterType) => {
    if (!product || !product.variants || !starterType) return null;
    const wantDecaf = starterType === 'decaf';
    return (
      product.variants.find((variant) => {
        const text = variantHaystack(variant);
        return wantDecaf
          ? text.includes('decaf')
          : (text.includes('flavour') || text.includes('caffein') || text.includes('caf')) &&
            !text.includes('decaf');
      }) || null
    );
  };

  const currentStarterType = () =>
    (typeof window.llFbStarterType === 'function' && window.llFbStarterType()) ||
    document.documentElement.getAttribute('data-ll-fb-starter-type') ||
    '';

  const applyStarterType = (starterType) => {
    if (!state.product || !starterType) return false;
    const match = findStarterVariant(state.product, starterType);
    if (!match) return false;
    state.variantId = match.id;
    return true;
  };

  const allocationFor = (variant, planId) => {
    if (!variant || !planId) return null;
    return (variant.allocations || []).find((a) => String(a.selling_plan_id) === String(planId)) || null;
  };

  const parseProduct = (button) => {
    const source = button.getAttribute('data-ll-quick-source');
    const card = button.closest('.ll-product-card');
    const script = source
      ? document.querySelector(source)
      : card && card.querySelector('[data-ll-quick-add-product]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (err) {
      return null;
    }
  };

  const render = () => {
    const product = state.product;
    const variant = currentVariant();
    if (!product || !variant) return;
    const hasPlans = product.selling_plans && product.selling_plans.length > 0;
    const planId = state.planId || (hasPlans ? product.selling_plans[0].id : '');
    state.planId = planId;
    const subAlloc = allocationFor(variant, planId);
    const displayPrice =
      state.purchase === 'subscribe' && subAlloc ? subAlloc.price_formatted : variant.price_formatted;
    const compare =
      state.purchase === 'subscribe' && subAlloc ? variant.price_formatted : variant.compare_at_price_formatted;

    const sizes =
      product.variants.length > 1
        ? product.variants
            .map((item) => {
              const selected = String(item.id) === String(variant.id);
              return `<label class="ll-quick-add__size${selected ? ' is-selected' : ''}">
                <input type="radio" name="ll-quick-size" value="${item.id}" ${selected ? 'checked' : ''} ${
                  item.available ? '' : 'disabled'
                }>
                <span>${escapeHtml(item.label || '')}</span>
              </label>`;
            })
            .join('')
        : '';

    const planOptions = (product.selling_plans || [])
      .map(
        (plan) =>
          `<option value="${escapeHtml(plan.id)}" ${String(plan.id) === String(planId) ? 'selected' : ''}>${escapeHtml(
            plan.name
          )}</option>`
      )
      .join('');

    const subscribeChecked = hasPlans && state.purchase === 'subscribe';
    const saveBadge =
      product.save_percent > 0 ? `<span class="ll-quick-add__save">SAVE ${product.save_percent}%</span>` : '';

    const plans = hasPlans
      ? `<div class="ll-quick-add__plans">
          <p class="ll-quick-add__plans-title">Purchase Options</p>
          <div class="ll-quick-add__plans-box">
            <label class="ll-quick-add__plan${state.purchase === 'onetime' ? ' is-selected' : ''}">
              <input type="radio" name="ll-quick-purchase" value="onetime" ${
                state.purchase === 'onetime' ? 'checked' : ''
              }>
              <span class="ll-quick-add__plan-name">One Time Purchase</span>
              <span class="ll-quick-add__plan-price">${escapeHtml(variant.price_formatted)}</span>
            </label>
            <label class="ll-quick-add__plan${subscribeChecked ? ' is-selected' : ''}">
              <input type="radio" name="ll-quick-purchase" value="subscribe" ${subscribeChecked ? 'checked' : ''}>
              <span class="ll-quick-add__plan-name">Subscribe and save ${saveBadge}</span>
              <span class="ll-quick-add__plan-price">
                <span>${escapeHtml(subAlloc ? subAlloc.price_formatted : variant.price_formatted)}</span>
                <s>${escapeHtml(variant.price_formatted)}</s>
              </span>
              <span class="ll-quick-add__freq">
                <span class="ll-quick-add__freq-label">Delivery frequency</span>
                <select class="ll-quick-add__freq-select" data-ll-quick-frequency aria-label="Delivery frequency">
                  ${planOptions}
                </select>
              </span>
            </label>
          </div>
        </div>`
      : '';

    bodyEl().innerHTML = `
      ${product.type ? `<p class="ll-quick-add__type">${escapeHtml(product.type)}</p>` : ''}
      <h2 class="ll-quick-add__title" id="ll-quick-add-title">${escapeHtml(product.title)}</h2>
      <p class="ll-quick-add__price">
        <span data-ll-quick-price>${escapeHtml(displayPrice)}</span>
        ${
          compare && compare !== displayPrice
            ? `<s data-ll-quick-compare>${escapeHtml(compare)}</s>`
            : ''
        }
      </p>
      <form class="ll-quick-add__form" data-ll-quick-form>
        <div class="appstle_sub_widget" hidden aria-hidden="true">
          <input type="radio" name="selling_plan" value="${
            subscribeChecked ? planId : ''
          }" data-ll-quick-selling-plan ${subscribeChecked ? 'checked' : ''}>
        </div>
        ${
          sizes
            ? `<fieldset class="ll-quick-add__sizes">
                <legend class="ll-quick-add__sizes-label">${escapeHtml(product.option_name || 'Size')}: ${escapeHtml(
                  variant.label || ''
                )}</legend>
                <div class="ll-quick-add__size-list">${sizes}</div>
              </fieldset>`
            : ''
        }
        ${plans}
        <div class="ll-quick-add__row">
          <div class="ll-quick-add__qty" role="group" aria-label="Quantity">
            <button type="button" data-ll-qty="-1" aria-label="Decrease quantity">−</button>
            <input type="number" name="quantity" min="1" max="99" value="${state.qty}" data-ll-quick-qty>
            <button type="button" data-ll-qty="1" aria-label="Increase quantity">+</button>
          </div>
          <button type="submit" class="ll-quick-add__atc" data-ll-quick-atc ${variant.available ? '' : 'disabled'}>
            ${variant.available ? 'ADD TO CART' : 'SOLD OUT'}
          </button>
        </div>
        <p class="ll-quick-add__error" data-ll-quick-error hidden></p>
        <a class="ll-quick-add__details" href="${escapeHtml(product.url)}">View full details</a>
      </form>
    `;
  };

  const open = (product, starterType) => {
    const el = root();
    if (!el || !product || !product.variants || !product.variants.length) return;
    lastFocus = document.activeElement;
    state.product = product;
    const typeMatch = findStarterVariant(product, starterType);
    const preferred = product.default_variant_id
      ? product.variants.find((v) => String(v.id) === String(product.default_variant_id))
      : null;
    const first =
      typeMatch ||
      (preferred && preferred.available ? preferred : null) ||
      product.variants.find((v) => v.available) ||
      product.variants[0];
    state.variantId = first.id;
    state.qty = 1;
    state.purchase = 'onetime';
    state.planId = product.selling_plans && product.selling_plans[0] ? product.selling_plans[0].id : '';
    render();
    el.hidden = false;
    requestAnimationFrame(() => {
      el.classList.add('is-open');
      const panel = el.querySelector('.ll-quick-add__panel');
      if (panel) panel.focus();
    });
    document.body.style.overflow = 'hidden';
  };

  const close = () => {
    const el = root();
    if (!el) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    const finish = () => {
      el.hidden = true;
      if (bodyEl()) bodyEl().innerHTML = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };
    window.setTimeout(finish, 450);
  };

  const syncAfterChange = () => {
    const form = bodyEl() && bodyEl().querySelector('[data-ll-quick-form]');
    if (form) {
      const qtyInput = form.querySelector('[data-ll-quick-qty]');
      if (qtyInput) state.qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    }
    render();
  };

  document.addEventListener('ll-fb-starter-type', (event) => {
    const el = root();
    if (!el || el.hidden || !state.product) return;
    if (applyStarterType(event.detail)) render();
  });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ll-quick-open]');
    if (opener) {
      event.preventDefault();
      const product = parseProduct(opener);
      if (product) {
        const isStarter =
          opener.getAttribute('data-ll-quick-source') === '#ll-fb-starter-product' ||
          Boolean(findStarterVariant(product, 'decaf') && findStarterVariant(product, 'flavoured'));
        const starterType = isStarter ? currentStarterType() || 'flavoured' : '';
        open(product, starterType);
      }
      return;
    }
    if (event.target.closest('[data-ll-quick-close]')) {
      event.preventDefault();
      close();
      return;
    }
    const qtyBtn = event.target.closest('[data-ll-qty]');
    if (qtyBtn) {
      event.preventDefault();
      const step = parseInt(qtyBtn.getAttribute('data-ll-qty'), 10) || 0;
      state.qty = Math.min(99, Math.max(1, state.qty + step));
      const input = bodyEl() && bodyEl().querySelector('[data-ll-quick-qty]');
      if (input) input.value = String(state.qty);
    }
  });

  document.addEventListener('change', (event) => {
    if (!root() || root().hidden) return;
    if (event.target.matches('input[name="ll-quick-size"]')) {
      state.variantId = event.target.value;
      syncAfterChange();
      return;
    }
    if (event.target.matches('input[name="ll-quick-purchase"]')) {
      state.purchase = event.target.value;
      syncAfterChange();
      return;
    }
    if (event.target.matches('[data-ll-quick-frequency]')) {
      state.planId = event.target.value;
      syncAfterChange();
      return;
    }
    if (event.target.matches('[data-ll-quick-qty]')) {
      state.qty = Math.max(1, parseInt(event.target.value, 10) || 1);
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ll-quick-form]');
    if (!form) return;
    event.preventDefault();
    const variant = currentVariant();
    const atc = form.querySelector('[data-ll-quick-atc]');
    const error = form.querySelector('[data-ll-quick-error]');
    if (!variant || !variant.available || !atc) return;
    atc.classList.add('is-loading');
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    const formData = new FormData();
    formData.set('id', String(variant.id));
    formData.set('quantity', String(state.qty || 1));
    if (state.purchase === 'subscribe' && state.planId) {
      formData.set('selling_plan', String(state.planId));
      const bridge = form.querySelector('[data-ll-quick-selling-plan]');
      if (bridge) {
        bridge.value = String(state.planId);
        bridge.checked = true;
      }
    }

    const onCartPage = isCartPage();
    const ui = cartUi();
    if (onCartPage) {
      formData.append('sections', cartPageSectionIds().join(','));
      formData.append('sections_url', window.location.pathname);
    } else if (ui && typeof ui.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        ui
          .getSectionsToRender()
          .map((section) => section.id)
          .join(',')
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof ui.setActiveElement === 'function') ui.setActiveElement(atc);
    } else {
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);
    }

    try {
      const response = await addToCart(formData);
      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to add to cart.');
      }
      close();
      if (onCartPage) {
        await refreshCartPage(data);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: data });
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.classList.remove('is-empty');
          drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
        }
        if (ui && typeof ui.renderContents === 'function' && data.sections) {
          ui.renderContents(data);
        } else if (drawer && typeof drawer.open === 'function') {
          drawer.open(atc);
        }
      }
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { source: 'll-quick-add', variantId: variant.id, data },
        })
      );
    } catch (err) {
      if (error) {
        error.hidden = false;
        error.textContent = err.message || 'Unable to add to cart.';
      }
    } finally {
      atc.classList.remove('is-loading');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root() && !root().hidden) close();
  });
})();
